import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Box, Button } from "@mui/material";
import PropTypes from 'prop-types';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridToolbarContainer, GridActionsCellItem, } from '@mui/x-data-grid';
import { randomId } from '@mui/x-data-grid-generator';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"
import saveBuckets from "../../components/managers/saveBuckets"
import ConfirmDialog from '../../components/ConfirmDialog';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import handleError from "../../hooks/handleError";


function EditToolbar(props) {
    const { setBuckets, setDisplayedBuckets } = props;

    const handleClick = () => {
        const id = randomId();
        const newRow = { id, name: '', actions: "INSERT" };
        setBuckets((oldRows) => [...oldRows, newRow])
        setDisplayedBuckets((oldRows) => [...oldRows, newRow]);
    };

    return (
        <GridToolbarContainer>
            <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                ADD BUCKET
            </Button>
        </GridToolbarContainer>
    );
}



EditToolbar.propTypes = {
    setDisplayedBuckets: PropTypes.func.isRequired,
};



const EditBuckets = () => {

    useEffect(() => {
        document.title = 'Buckets | Fretless Finance';
    }, []);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();
    var [buckets, setBuckets] = useState([]);
    var [DisplayedBuckets, setDisplayedBuckets] = useState([]);
    var [open, setOpen] = useState(false);
    var [deleteId, setDeleteId] = useState(0);
    const effectRan = useRef(false);
    var isMounted = useRef(false);
    const controller = new AbortController();




    useEffect(() => {
        if (effectRan.current === false) {

            isMounted.current = true;
            const controller = new AbortController();

            const getBuckets = async () => {
                try {
                    var BucketsResponse = await axiosPrivate.get('/buckets', {
                        signal: controller.signal
                    });
                    // isMounted && setBuckets(BucketsResponse.data);
                    setBuckets(BucketsResponse.data)
                    setDisplayedBuckets(BucketsResponse.data);

                } catch (err) {
                    if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    }
                    else {
                        handleError(err);
                    }
                }
            }

            getBuckets();
            effectRan.current = true;
        }
        return () => {
            isMounted.current = false;
            controller.abort();

        }


    }, [])




    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, actions: ((newRow.actions !== "INSERT" & newRow.actions !== "DELETE") ? "UPDATE" : newRow.actions) };
        setBuckets(buckets.map((row) => (row.id === updatedRow.id ? updatedRow : row)));
        setDisplayedBuckets(DisplayedBuckets.map((row) => ((row.id === updatedRow.id & updatedRow.actions !== "DELETE") ? updatedRow : row)));
        return updatedRow;
    };

    const deleteBucket = () => {
        const deletedRow = buckets.filter((row) => row.id === deleteId)[0]
        deletedRow.actions = "DELETE"

        processRowUpdate(deletedRow)
        setDisplayedBuckets(DisplayedBuckets.filter((row) => row.id !== deleteId));
    };

    const saveChangesHandler = event => {
        var updatedArray = buckets.filter((row) => row.actions !== "DELETE")
        updatedArray = updatedArray.map(row => ({ ...row, actions: null }));

        saveBuckets(buckets);
        setBuckets(updatedArray)
    }

    const columns = [
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => {
                            setDeleteId(id);
                            setOpen(true);
                        }}
                        color="inherit"
                    />,
                ];
            },
        },
        {
            field: "name",
            headerName: "Name",
            width: 300,
            type: "string",
            headerAlign: "center",
            align: "center",
            editable: true,
        },
        {
            field: "bucket_type",
            headerName: "Type",
            width: 150,
            type: "string",
            headerAlign: "center",
            align: "center",
            editable: true,
        },
        {
            field: "parent_bucket",
            headerName: "Parent Bucket",
            width: 200,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "fill_priority",
            headerName: "Fill Priority",
            width: 100,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "amount",
            headerName: "Amount",
            width: 100,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "cap",
            headerName: "Cap",
            width: 100,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "sort_index",
            headerName: "Sort",
            width: 100,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
    ];


    return (
        <Box m="20px">
            <Header
                title="BUCKETS (edit)"
                titleSize="h2"
                subtitle="Imaginary buckets ya keep ya money in"
                subtitleSize="h5"
            />

            < ToastContainer />

            <Box
                m="40px 0 0 0"
                height="67vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[400],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[400],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                    },
                }}
            >
                <DataGrid
                    rows={DisplayedBuckets}
                    columns={columns}
                    CanUserAddRows="True"
                    CanUserDeleteRows="True"
                    processRowUpdate={processRowUpdate}
                    components={{ Toolbar: EditToolbar }}
                    componentsProps={{
                        toolbar: { buckets, setBuckets, setDisplayedBuckets }
                    }}
                    experimentalFeatures={{ newEditingApi: true }}
                    options={{ customToolbar: () => { } }}
                />
                <ConfirmDialog
                    title="Delete Bucket"
                    message="Are you sure you want to delete this?"
                    confirmBtnText="DELETE"
                    open={open}
                    setOpen={setOpen}
                    onConfirm={deleteBucket}>
                </ConfirmDialog>
            </Box>
            <Box padding="1rem" align="right">
                <Button onClick={saveChangesHandler}
                    sx={{
                        backgroundColor: colors.greenAccent[500],
                        color: "#ffffff",
                        '&:hover': {
                            backgroundColor: colors.greenAccent[300],
                            color: "#ffffff",
                        },
                        fontSize: "14px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                    }}
                >
                    <SaveIcon sx={{ mr: "10px" }} />
                    Save Changes
                </Button>
            </Box>

        </Box >
    );
};

export default EditBuckets;